import React, {useCallback, useState} from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import {Link, makeStyles} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
}));

const AddressCell = ({ latitude, longitude }) => {
    const classes = useStyles();
    const [address, setAddress] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchAddress = useCallback(async () => {
        if (!latitude || !longitude) return;

        setLoading(true);
        try {
            const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
            if (response.ok) {
                const data = await response.json();
                setAddress(data.display_name || 'Address not found');
            } else {
                setAddress('Failed to fetch address');
            }
        } catch (error) {
            console.error("Failed to fetch address:", error);
            setAddress('Error fetching address');
        } finally {
            setLoading(false);
        }
    }, [latitude, longitude]);

    if (loading) {
        return <CircularProgress size={20} color="secondary"/>;
    }

    if (address) {
        return (
            <Tooltip title={address} placement="top">
                <div
                    style={{
                        width: '100%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {address}
                </div>
            </Tooltip>
        );
    }

    return (
            <Link
                component="button"
                onClick={fetchAddress}
                className={classes.color}
                underline="always"
            >
                {`${latitude.toFixed(5)}, ${longitude.toFixed(5)}`}
            </Link>
    );
};

export default AddressCell;